<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead :title="'Sedna Reservation Logs'"></cardHead>
          <div>
            <Form
              method="dialog"
              v-slot="{ errors }"
              class="floating-labels row  p-20 p-b-10"
              ref="form"
            >
              <div class="col">
                <searchSelect
                  :title="'HotelId'"
                  v-model="model.HotelId"
                  :errors="errors"
                  :data="
                    $orderByArray(
                      hotels.map((x) => {
                        return {
                          value: x.Id,
                          text: x.HotelName,
                        };
                      }),
                      'Name',
                      false,
                      false
                    )
                  "
                >
                </searchSelect>
              </div>
              <div class="col">
                <formGroup
                  type="number"
                  :title="'RecId'"
                  v-model="model.RecId"
                  :errors="errors"
                  @keydown.enter="get()"
                  :rules="{ required: true }"
                >
                </formGroup>
              </div>
              <div class="col-auto">
                <Btn
                  class="btn-success"
                  @click="get()"
                  :disabled="load"
                  :process="load"
                  >Get Logs</Btn
                >
              </div>
            </Form>
            <ul
              class="nav nav-tabs profile-tab border-top"
              v-show="data != null"
            >
              <li class="nav-item m-0">
                <a
                  href="javascript:;"
                  class="nav-link"
                  :class="{ active: tab == 'logs' }"
                  @click="tab = 'logs'"
                  >Logs</a
                >
              </li>
              <li class="nav-item m-0">
                <a
                  href="javascript:;"
                  class="nav-link"
                  :class="{ active: tab == 'reservation' }"
                  @click="tab = 'reservation'"
                  >Reservations</a
                >
              </li>
            </ul>
            <dataTable
              :name="'kolayrezednaReservationLogs'"
              v-if="data != null"
              v-show="tab == 'logs'"
              ref="agGrid"
              :data="data.Logs"
              :columnDefs="columnDefs"
            ></dataTable>

            <pre v-if="data != null" v-show="tab == 'reservation'">{{
              data.Reservation
            }}</pre>
            <load-area v-if="load" class="border-top"></load-area>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "SednaReservationLogs",
  data() {
    return {
      tab: "logs",
      data: null,
      hotels: [],
      model: {
        HotelId: null,
        RecId: null,
      },
      columnDefs: [
        {
          headerName: "RecId",
          field: "RecId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "UserCode",
          field: "UserCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "CompanyCode",
          field: "CompanyCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "HotelDate",
          field: "HotelDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "FieldName",
          field: "FieldName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "TableName",
          field: "TableName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Old",
          field: "Old",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "New",
          field: "New",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "ADateTime",
          field: "ADateTime",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "TableId",
          field: "TableId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "AType",
          field: "AType",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "PCName",
          field: "PCName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "FormName",
          field: "FormName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "MasterId",
          field: "MasterId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "ResId",
          field: "ResId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "PtcId",
          field: "PtcId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "CompanyRecId",
          field: "CompanyRecId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "OldRecId",
          field: "OldRecId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
      ],
      load: false,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Hotels/KolayrezHotels`).then((response) => {
      this.hotels = this.$orderByArray(
        response.data.filter((x) => x.SoftwareId == 5 || x.SoftwareId == 11),
        "HotelName",
        false,
        false
      );
    });
  },
  methods: {
    get() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.data = null;
          this.load = true;
          this.$appAxiosAdmin
            .post(`PMS/Sedna/GetLogs`, this.model)
            .then((response) => {
              this.tab = "logs";
              this.data = response.data;
              this.load = false;
            })
            .catch((err) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: err,
              });
              this.load = false;
            });
        }
      });
    },
    reload() {
      this.get();
    },
  },
};
</script>
